import { render } from "./ClientFormData.vue?vue&type=template&id=d304926e"
import script from "./ClientFormData.vue?vue&type=script&lang=js"
export * from "./ClientFormData.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__